import styles from "./OnboardingStyles.module.css";
import { useTranslation } from "react-i18next";
import AddressInput from "../Input/AddressInput/AddressInput";
import DatePicker from "../DatePicker/DatePicker";
import type { OnboardingFormData } from "../../types/onboarding.types";
import {
    getOnboardingDietOptions,
    getOnboardingEventOptions,
    getOnboardingPackagingMap,
} from "./onboardingOptions";

type OnboardingRecapProps = {
    formData: OnboardingFormData;
    cartDatesISO: string[];
    address: string;
};

const OnboardingRecap = ({ formData, cartDatesISO, address }: OnboardingRecapProps) => {
    const { t } = useTranslation();
    const dietOptions = getOnboardingDietOptions(t);
    const packagingMap = getOnboardingPackagingMap(t);
    const eventOptions = getOnboardingEventOptions(t);
    const packagingLabel =
        packagingMap[formData.packagingType as keyof typeof packagingMap] ??
        t("onboarding.steps.9.inputs.default_service");

    return (
        <div className={styles.Recap}>
            <div className={styles.RecapBox}>
                <div className={styles.RecapItem}>
                    <p className={styles.RecapItemTitle}>{t("onboarding.steps.9.inputs.people")}</p>
                    <div className={styles.RecapItemContent}>
                        <div className={styles.RecapTextBox}>
                            <p>
                                {formData.peopleAmount && formData.peopleAmount > 0
                                    ? formData.peopleAmount
                                    : 0}{" "}
                                {t("onboarding.steps.9.inputs.people_unit")}
                            </p>
                        </div>
                    </div>
                </div>

                <div className={styles.RecapItem}>
                    <p className={styles.RecapItemTitle}>{t("onboarding.steps.9.inputs.types")}</p>
                    <div className={styles.RecapItemContent}>
                        {formData.actionType?.map((type: string) => (
                            <div className={styles.RecapPickBox} key={type}>
                                <p>{type && eventOptions.find((event) => event.slug === type)?.text}</p>
                            </div>
                        ))}
                        {formData.actionType?.length === 0 ? (
                            <div className={styles.RecapNotSet}>
                                <p>{t("onboarding.steps.9.inputs.no_types")}</p>
                            </div>
                        ) : null}
                    </div>
                </div>

                <div className={styles.RecapItem}>
                    <p className={styles.RecapItemTitle}>{t("onboarding.steps.9.inputs.service")}</p>
                    <div className={styles.RecapItemContent}>
                        <div className={styles.RecapPickBox}>
                            <p>{packagingLabel}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${styles.RecapBox} ${styles.SecondBox}`}>
                <div className={styles.RecapItem}>
                    <p className={styles.RecapItemTitle}>
                        {t("onboarding.steps.9.inputs.special_requests")}
                    </p>
                    <div className={styles.RecapItemContent}>
                        {formData.specialRequests?.map((request: string) => {
                            if (request !== "") {
                                return (
                                    <div className={styles.RecapPickBox} key={request}>
                                        <p>
                                            {request &&
                                                dietOptions.find((diet) => diet.slug === request)?.text}
                                        </p>
                                    </div>
                                );
                            }
                            return null;
                        })}

                        {formData.note && (
                            <div className={styles.RecapPickBox} key={formData.note}>
                                <p>{formData.note}</p>
                            </div>
                        )}

                        {formData.note !== "" || formData.specialRequests?.length !== 0 ? null : (
                            <div className={styles.RecapNotSet}>
                                <p>{t("onboarding.steps.9.inputs.no_special_requests")}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.RecapItem}>
                    <p className={styles.RecapItemTitle}>
                        {t("onboarding.steps.9.inputs.date_address")}
                    </p>
                    <div className={styles.RecapItemContentColumn}>
                        <AddressInput
                            showOnly={true}
                            value={address}
                            wrapperClassName={styles.RecapInputWrap}
                            className={styles.RecapInput}
                        />
                        <DatePicker
                            showOnly={true}
                            selectedDates={cartDatesISO}
                            wrapperClassName={styles.RecapInputWrap}
                            className={styles.RecapInput}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingRecap;
